const menu = state => state.menu
const menuItems = state => state.menu.items
const navItemMap = state => state.menu.navItemMap
const navItems = state => state.menu.navItems
const user = state => state.user
const styles = state => state.styles
const appState = state => state.appState
const clubSettings = state => state.clubSettings
const appConfig = state => state.appConfig
/*
const componententry = state => {
  return state.menu.items.filter(c => c.meta && c.meta.label === 'Components')[0]
}
*/

export {
  user,
  styles,
  appState,
  menu,
  menuItems,
  navItemMap,
  navItems,
  clubSettings,
  appConfig
  // componententry
}
